module.exports = __webpack_public_path__ + "static/media/icon-7.4404439c.svg";